/* eslint-disable import/prefer-default-export */

export function possessify(theString) {
  const regex = /^.*(s){1}$/i
  if (regex.test(theString)) {
    return `${theString}'`
  }
  return `${theString}'s`
}
